<template>
  <div class="category-tab">
    <div class="category-tab-item" @click="entoRecommendPage('zero')">
      <div class="category-tab-img">
        <img src="../../../assets/icon/zero_buy.png" />
      </div>
      <div class="category-txt">0元专区</div>
    </div>
    <div class="category-tab-item" @click="entoRecommendPage('dollar')">
      <div class="category-tab-img">
        <img src="../../../assets/icon/one_buy.png" />
      </div>
      <div class="category-txt">9.9元包邮</div>
    </div>
    <div class="category-tab-item" @click="entoRecommendPage('unSearchCenter')">
      <div class="category-tab-img">
        <img src="../../../assets/icon/no_search.png" />
      </div>
      <div class="category-txt">补贴专区</div>
    </div>
    <div class="category-tab-item" @click="entoRecommendPage('human')">
      <!-- <div class='category-tab-img'>
        <img v-if="isOpenPresell" src="../../../assets/icon/new_sale.png" />
        <img v-else src="../../../assets/icon/quality.png" />
      </div>
      <div class='category-txt'>{{isOpenPresell ? '新品预售' : '品质专区'}}</div> -->
      <div class="category-tab-img">
        <img src="../../../assets/icon/quality.png" />
      </div>
      <div class="category-txt">品质专区</div>
    </div>
    <div class="category-tab-item" @click="entoRecommendPage('new')">
      <div class="category-tab-img">
        <img src="../../../assets/icon/new_goods.png" />
      </div>
      <div class="category-txt">新品首发</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  // props: {
  //   // // 包邮配置信息
  //   // selectAmount: {
  //   //   type: Number,
  //   //   default: 0
  //   // },
  //   // 是否开启新品预售
  //   isOpenPresell: {
  //     type: Boolean,
  //     default: false
  //   }
  // },
  methods: {
    entoRecommendPage(val) {
      if (val === 'zero') {
        // 0元专区
        this.$router.push({ name: 'zeroBuyMain' })
      } else if (val === 'dollar') {
        // 一元包邮
        this.$router.push({ name: 'onePackage' })
      } else if (val === 'unsearch') {
        // 补贴专区
        this.$router.push({ name: 'unSearchCenter' })
      } else if (val === 'human') {
        // if (this.isOpenPresell) {
        //   // 新品预售
        //   this.$router.push({ name: 'presellGood' })
        // } else {
        //   // 品质专区
        //   this.$router.push({ name: 'qualityZone' })
        // }
        // 品质专区
        this.$router.push({ name: 'qualityZone' })
      } else if (val === 'unSearchCenter') {
        // 补贴专区
        this.$router.push({ name: 'unSearchCenter' })
      } else {
        // 新品首发
        this.$router.push({ name: 'newProduct' })
      }
    }
  }
}
</script>

<style scoped>
.category-tab {
  display: flex;
  height: 90px;
  background: #fff;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 0px 10px;
  margin-bottom: 11px;
  border-radius: 7px;
  box-shadow: 0 3px 4px 0 #dfdfdf;
}
.category-tab-item {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  height: 100%;
  flex-grow: 1;
}
.category-tab-item:active {
  background: #f5f5f5;
}
.category-tab-img {
  height: 26px;
  width: 26px;
  align-self: center;
}
.category-tab-img img {
  width: 100%;
  height: 100%;
}
.category-tab-item:nth-of-type(3) img {
  width: 24px;
  height: 24px;
  margin: 2px 1px 0 1px;
}
.category-tab-item:nth-of-type(4) img {
  width: 28px;
  height: 27px;
}
.category-txt {
  color: #79849e;
  font-size: 13px;
  margin-top: 10px;
  text-align: center;
}
</style>
